import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { StorageService } from './storage.service';

const MARKETING_CONSENTS_KEY = 'MARKETING_CONSENTS';

export interface MarketingConsents {
  option1: boolean,
  option2: boolean,
  option3: boolean,
  combine?: boolean
}

@Injectable({
  providedIn: 'root'
})
export class MarketingConsentsService {
  private _storage = inject(StorageService);

  private _marketingConsents: MarketingConsents = {
    option1: true,
    option2: true,
    option3: true,
    combine: true
  };

  private _marketingConsents$ = new BehaviorSubject<MarketingConsents>(this._marketingConsents);
  public marketingConsents$ = this._marketingConsents$.asObservable();

  public setMarketingConsents(marketingConsents: MarketingConsents) {
    this._marketingConsents = {
      ...marketingConsents,
      combine: marketingConsents.option1 && marketingConsents.option2 && marketingConsents.option3
    };

    this._marketingConsents$.next(this._marketingConsents);
    this._storage.store(MARKETING_CONSENTS_KEY, this._marketingConsents);
  }

  public getMarketingConsents() {
    return this._storage
      .get(MARKETING_CONSENTS_KEY)
      .then((marketingConsent: MarketingConsents) => {

        if (marketingConsent) {
          this._marketingConsents = marketingConsent;
          this._marketingConsents$.next(marketingConsent);

          return marketingConsent;
        }

        return this._marketingConsents;
      })
  }

}
